/**
 * SSR 응답 상태 전파 컨텍스트 (soft-404 방지).
 *
 * entry-server.tsx 가 렌더마다 mutable 객체({ status: 200 })를 주입하고,
 * 페이지 컴포넌트가 렌더 중에 status/redirect 를 세팅하면 server.ts 가
 * 그 값으로 HTTP 응답(404, 301+Location)을 내린다. (HostContext 와 동일 패턴)
 *
 * 클라이언트(CSR)에서는 Provider 가 없어 항상 null — 세팅 시도는 no-op 이 된다.
 */
import { createContext, useContext } from 'react'

export interface SsrStatus {
  /** HTTP 응답 상태코드 (기본 200) */
  status: number
  /** 301 리다이렉트 대상 경로 — 설정 시 server.ts 가 301 + Location 으로 응답 */
  redirect?: string
}

export const SsrStatusContext = createContext<SsrStatus | null>(null)

/** SSR 상태 객체 (서버 렌더 중에만 non-null) */
export function useSsrStatus(): SsrStatus | null {
  return useContext(SsrStatusContext)
}
